import { useContext } from 'react';
import { AuthContext } from '.';
import { AuthContextType } from '../context-auth-types';

export const useAuth = (): AuthContextType => useContext<AuthContextType>(AuthContext);
